export enum DocumentCategories{
    Headshot = "Headshot",
    CV = "CV",
    W9TaxFile = "W9 Tax File",
    SamplePresentationOthers = "Sample Presentation & Others",
    VendorForm = "Vendor Form"
}